module.exports = __webpack_public_path__ + "0fe620427192eacbada3333a6d13feac.pdf";